module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedLight.4994728.woff2";